import { createReducer } from '@reduxjs/toolkit'
import { ComponentType } from 'react'

export interface LiquidityProvider {
  id: string
  name: string
  imageUrl: string | ComponentType
}

export interface ProvidersState {
  readonly availableProviders: LiquidityProvider[]
  readonly selectedProviders: string[] // Array of provider IDs
  readonly allProviders: boolean
}

const initialState: ProvidersState = {
  availableProviders: [],
  selectedProviders: [],
  allProviders: true,
}

import { clearSelectedProviders, selectAllProviders, setAvailableProviders, toggleProvider } from './actions'

export default createReducer<ProvidersState>(initialState, (builder) =>
  builder
    .addCase(setAvailableProviders, (state, { payload: { providers } }) => {
      // Filter out providers with React components before saving to state
      const serializableProviders = providers.map((provider) => ({
        ...provider,
        imageUrl: typeof provider.imageUrl === 'string' ? provider.imageUrl : '',
      }))
      state.availableProviders = serializableProviders
    })
    .addCase(toggleProvider, (state, { payload: { providerId, defaultSelection } }) => {
      if (state.allProviders ?? true) {
        // The first toggle starts from what the chain selects by default, not from every provider
        state.selectedProviders = defaultSelection.includes(providerId)
          ? defaultSelection.filter((id) => id !== providerId)
          : [...defaultSelection, providerId]
        state.allProviders = false
      } else {
        const index = state.selectedProviders.indexOf(providerId)
        if (index >= 0) {
          state.selectedProviders.splice(index, 1)
        } else {
          state.selectedProviders.push(providerId)
        }
      }
    })
    .addCase(clearSelectedProviders, (state) => {
      state.selectedProviders = ['kodiak']
      state.allProviders = false
    })
    .addCase(selectAllProviders, (state) => {
      // An explicit list: `allProviders` means the chain default, which can leave some providers off
      state.selectedProviders = state.availableProviders.map((p) => p.id)
      state.allProviders = false
    })
)
